module.exports = __webpack_public_path__ + "img/pc-list-two-cart.0503f39c.jpg";